module.exports = __webpack_public_path__ + "img/pinterest.99a6326e.svg";